import { matchSorter } from 'match-sorter';

/**
 * PGSS-5735: what the product save sends for its supplier.
 *
 * The backend changes a product's supplier only when the save names one: absent keeps it, `{}` clears it, `{ id }`
 * sets it. The form used to send nothing, and the backend copied that over the stored supplier on every edit.
 * Untouched field: send nothing (keep). Changed: the chosen supplier, or `{}` when it was cleared.
 */
export function productSupplierPayload(selected, isDirty) {
  if (!isDirty) return undefined;
  return selected?.id ? { id: selected.id } : {};
}

/** Supplier is kept for inventory products only: stock products that are not custom. */
export function isInventoryProduct(product) {
  return Boolean(product?.is_stock_product) && !product?.is_custom;
}

/** The product's supplier as the form holds it: only what the picker needs, and only for inventory products. */
export function productSupplierInitValue(product) {
  const supplier = product?.supplier;
  return isInventoryProduct(product) && supplier?.id ? { id: supplier.id, name: supplier.name || '' } : null;
}

/**
 * The Supplier picker's filter: suppliers whose name or email contains what was typed, best match first. The shared
 * AuraControlledAutocomplete does not filter a single-select list on its own (it returns every option unless the
 * field is creatable), so without this, typing did not narrow the list.
 */
export function filterSuppliers(options, { inputValue } = {}) {
  const query = (inputValue || '').trim();
  if (!query) return options;
  return matchSorter(options, query, { keys: ['name', 'email'], threshold: matchSorter.rankings.CONTAINS });
}
